{
  "GenericAdminList_Footer_Add": "Ajouter",
  "GenericAdminList_Footer_View": "Voir",
  "GenericAdminList_Footer_Change": "Changement",
  "GenericAdminList_Footer_Delete": "Supprimer",
  "GenericAdminList_Footer_Selected": "{} Sélectionné",
  "GenericAdminList_Footer_NoRows": "Rien à voir ici...",
  "NAME": "GenericAdminListLanguage"
}